<template>
  <PatientCard v-if="detailTop" :detailTop="detailTop" />
</template>

<script>
// @ is an alias to /src

import PatientCard from "@/components/PatientCard.vue";
import { setKartuPasien } from "@/data/helper.js";

export default {
  name: "PasienCetakKartu",
  components: {
    PatientCard,
  },
  data: function() {
    return { fromUrl: "", plainUrl: "", detailTop: null };
  },
  methods: {
    activateTab(tab) {
      this.tabActive = tab.link;
      this.tabs = this.tabs.map((item) => {
        if (item.active) {
          item.active = false;
        }
        if (tab.link == item.link) {
          item.active = true;
        }
        return item;
      });
    },
    displayData: async function() {
      this.loadedTop = false;
      this.loaded = false;
      this.errors = [];
      this.nDisplay = 7;
      try {
        let result = await this.$store.state.HTTP.get(
          `pasien/${this.$route.params.id}`
        );
        if (result.status == "200") {
          this.pasien = result.data;
          this.detailTop = setKartuPasien(this.pasien);
          this.loadedTop = true;
          setTimeout(() => {
            window.print();
          }, 500);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
  },

  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.displayData();
  },
};
</script>
